/**
 * Created by marlon.jerez on 07/07/2016.
 */

if(window.REGMAGICFIX === true){
	var global_page_no = 1;
	function gotonext(){

		maxpage = 1 ;
		REGMAGIC_JS_VALIDATOR();
		if(jQuery("#rm_form_page_"+global_page_no+" :input").length > 0)
		{
			var valid = jQuery("#rm_form_page_"+global_page_no+" :input").valid();
			if(!valid)
			{
				jQuery(document).find("input.rm-form-field-invalid-msg")[0].focus();
				return;
			}
		}


		global_page_no++;

		//skip blank form pages
		while(jQuery("#rm_form_page_"+global_page_no+" :input").length == 0)
		{
			if(maxpage <= global_page_no)
			{
				if(jQuery("#rm_form_page_"+global_page_no+" :input").length == 0){
					jQuery("#rm_next_form_page_button").attr('type','submit');
					return;
				}
				else
					break;
			}

			global_page_no++;
		}


		if(maxpage < global_page_no)
		{
			global_page_no = maxpage;
			jQuery("#rm_next_form_page_button").attr('type','submit');
			return;
		}

		jQuery(".rmformpage").each(function (){
			var visibledivid = "rm_form_page_"+global_page_no;
			if(jQuery(this).attr('id') == visibledivid)
				jQuery(this).show();
			else
				jQuery(this).hide();
		})
		jQuery("#rm_prev_form_page_button").prop('disabled',false);

	}

	function gotoprev(){

		maxpage = 1 ;
		global_page_no--;
		jQuery("#rm_next_form_page_button").attr('type','button');

		//skip blank form pages
		while(jQuery("#rm_form_page_"+global_page_no+" :input").length == 0)
		{
			if(1 >= global_page_no)
			{
				if(jQuery("#rm_form_page_"+global_page_no+" :input").length == 0){
					global_page_no = 1;
					jQuery("#rm_prev_form_page_button").prop('disabled',true);
					return;
				}
				else
					break;
			}

			global_page_no--;
		}

		jQuery(".rmformpage").each(function (){
			var visibledivid = "rm_form_page_"+global_page_no;
			if(jQuery(this).attr('id') == visibledivid)
				jQuery(this).show();
			else
				jQuery(this).hide();
		})

		if(global_page_no <= 1)
		{
			global_page_no = 1;
			jQuery("#rm_prev_form_page_button").prop('disabled',true);
		}
	};
}
if(typeof REGMAGIC_INIT === 'function'){
	REGMAGIC_INIT();
}
